import classNames from 'classnames';
import { memo } from 'react';

import { useGeneralLibraryMetadata } from '~/components/LibraryBeta/hooks/useGeneralLibraryMetadata';

type GeneralLibraryIconProps = {
  className?: string;
};

export const GeneralLibraryIcon = memo(({ className }: GeneralLibraryIconProps) => {
  const { generalLibraryIcon, generalLibraryColor } = useGeneralLibraryMetadata();

  return (
    <div
      data-testid="general-library-icon"
      className={classNames(
        'flex size-6 items-center justify-center rounded-4 bg-grey-4 transition-colors duration-1000',
        className,
      )}
      style={{ backgroundColor: generalLibraryColor.hex }}
    >
      {generalLibraryIcon}
    </div>
  );
});

GeneralLibraryIcon.displayName = 'GeneralLibraryIcon';
